module.exports = __webpack_public_path__ + "img/tech12.bf51acb4.png";